import React from 'react';
import { Pressable, Text, TextInput, View } from 'react-native';
import i18n from './../util/i18n';
import { addCategory, getCategory, updateCategory } from '../services/category.service';
import { Button, Checkbox, FormControlLabel, Grid2, Stack, TextField } from '@mui/material';

i18n.locale = navigator.language;

class AddEditCategory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            category_id: this?.props?.route?.params?.category || null,
            name: '',
            position: '',
            no_points: false
        };
    }

    async componentDidMount() {
        this.getCategory();
    }

    getCategory = async () => {
        if (this.state.category_id) {
            let category = await getCategory(this.state.category_id);
            category = category.category;
            this.setState({
                name: category.name,
                position: category.position,
                no_points: category.no_points
            });
        }
    }

    saveCategory = async () => {

        let response;
        let payload = {
            name: this.state.name,
            position: this.state.position,
            no_points: this.state.no_points
        }

        if (this.state.category_id) {
            response = await updateCategory(this.state.category_id, payload);
        } else {
            response = await addCategory(payload);
        }

        if (response.error) {
            alert(response.error);
            return false;
        }
        return true;
    }

    render() {
        return (
            <View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                    <Text style={{ padding: 10, fontSize: 25 }}>
                        {this.state.category_id ? i18n.t('edit_category') : i18n.t('add_category')}
                    </Text>
                </View>

                <Stack spacing={2} style={{ padding: 10 }}>
                    <TextField
                        size='small'
                        placeholder={i18n.t('name')}
                        label={i18n.t('name')}
                        value={this.state.name}
                        onChange={(e) => {
                            this.setState({ name: e.target.value });
                        }}
                    />
                    <TextField
                        size='small'
                        placeholder={i18n.t('position')}
                        label={i18n.t('position')}
                        value={this.state.position}
                        onChange={(e) => {
                            this.setState({ position: e.target.value });
                        }}
                        onBlur={() => {
                            // convert to integer
                            let position = parseInt(this.state.position);
                            if (isNaN(position)) {
                                this.setState({ position: '' });
                                return;
                            }
                            this.setState({ position: position });
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.no_points}
                                onChange={(e) => {
                                    this.setState({ no_points: e.target.checked });
                                }}
                            />
                        }
                        label={i18n.t('no_points')}
                    />
                </Stack>

                <Grid2 container sx={{ marginTop: 2 }}>
                    <Stack spacing={2} direction={'row'} style={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: 'gray', flex: 1 }}
                            onClick={() => {
                                this.props.navigation.navigate('Categories');
                            }}
                        >
                            {i18n.t('cancel')}
                        </Button>
                        <Button
                            variant="contained"
                            style={{ flex: 1 }}
                            onClick={async () => {
                                let response = await this.saveCategory();
                                if (response)
                                    this.props.navigation.navigate('Categories');
                            }}
                        >
                            {i18n.t('save')}
                        </Button>
                    </Stack>
                </Grid2>
                
                
            </View>
        )
    }
}

export default AddEditCategory;
